import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Ingredient} from '../../model/ingredient';
import {ItemCategory} from '../../model/item-category';
import {IngredientService} from '../../ingredient.service';

@Component({
    selector: 'app-ingredients-list',
    templateUrl: './ingredients-list.component.html',
    styleUrls: ['./ingredients-list.component.scss'],
    standalone: false
})
export class IngredientsListComponent implements OnInit {

  displayNewOnly = true;
  ingredients: Ingredient[] = [];
  newIngredients: Ingredient[];
  list: Ingredient[] = [];

  constructor(private ingredientService: IngredientService, private ref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.ingredientService.ingredients$.asObservable().subscribe(ingredients => {
      this.ingredients = ingredients;
      this.newIngredients = this.ingredients.filter(ingredient => ingredient.new);
      this.list = this.displayNewOnly ? this.newIngredients : this.ingredients;
    });
  }

  updateType(ingredient: Ingredient, category: ItemCategory): void {
    this.ingredientService.updateCategory(ingredient, category);
  }

  toggleDisplayNew(): void {
    if (this.displayNewOnly) {
      this.displayNewOnly = false;
      this.list = this.ingredients;
    } else {
      this.displayNewOnly = true;
      this.list = this.newIngredients;
    }

    this.ref.detectChanges();
  }

  trackById(index: number, item: any): any {
    return item.id;
  }
}
